import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth/use_auth'
import { Box, CircularProgress, Typography } from '@mui/material'

interface GuestOnlyRouteProps {
  children: React.ReactNode
  redirectTo?: string
}

/**
 * ゲスト専用ルートのコンポーネント
 * 未認証の場合のみ子コンポーネントを表示
 * 認証済みの場合は指定されたページにリダイレクト
 */
const GuestOnlyRoute: React.FC<GuestOnlyRouteProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { isAuthenticated, initialize, initialized } = useAuth()

  useEffect(() => {
    // アプリ起動時に認証状態を初期化
    initialize()
  }, [initialize])

  // ローディング中は読み込み画面を表示
  if (!initialized) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary">
          認証状態を確認中...
        </Typography>
      </Box>
    )
  }

  // 認証済みの場合は指定されたページにリダイレクト
  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />
  }

  // 未認証の場合は子コンポーネントを表示
  return <>{children}</>
}

export default GuestOnlyRoute
